// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"c9fb0d22","480":"1efa080f","681":"c2ba4b19","787":"0f8d78ff","815":"483d0ee0","849":"40df6e8d"}[chunkId] + ".chunk.js";
};